import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "../features/apiServices/apiClient";
import safeJSON from "./safeJSON";
import {
  UPGRADE_ROUTE,
  getSubscriptionStatus,
  isSubscriptionBlocked,
  setSubscriptionStatus,
} from "../features/subscription/subscriptionState";

/**
 * Route guard for the authenticated area.
 *
 * Requires a valid session AND a subscription that is not expired. The guard
 * re-runs on every navigation, including browser Back, which is what keeps the
 * upgrade screen from being bypassed through history.
 */
export default function ProtectedRoute({ children }) {
  const [ready, setReady] = useState(false);
  const [authorized, setAuthorized] = useState(false);
  const [blocked, setBlocked] = useState(() =>
    isSubscriptionBlocked(getSubscriptionStatus())
  );

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const tenant = safeJSON("tenant");

    setAuthorized(Boolean(token && tenant?.slug));
    setReady(true);
  }, []);

  // Revalidate against the API so a subscription that expired (or was
  // reactivated) server-side is reflected without a new login.
  useEffect(() => {
    if (!authorized) return undefined;

    const activeRestaurant = safeJSON("activeRestaurant");
    if (!activeRestaurant?.id) return undefined;

    let alive = true;

    api
      .get("/auth/assinatura/status", {
        headers: { "x-restaurant-id": activeRestaurant.id },
      })
      .then((res) => {
        if (!alive) return;
        const status = res.data?.status;
        setSubscriptionStatus(status);
        setBlocked(isSubscriptionBlocked(status));
      })
      .catch(() => {
        // Network/API failure keeps the cached decision.
      });

    return () => {
      alive = false;
    };
  }, [authorized]);

  if (!ready) {
    return <div>Carregando sessão...</div>;
  }

  if (!authorized) {
    return <Navigate to="/login" replace />;
  }

  if (blocked) {
    return <Navigate to={UPGRADE_ROUTE} replace />;
  }

  return children;
}
